import classNames from 'classnames'
import { BellOff } from 'lucide-react'
import type { RemindersPausedNoticeProps } from './reminders-paused-notice.interface'
import classes from './reminders-paused-notice.module.scss'

export function RemindersPausedNotice({ children, aside, variant = 'editor', className }: RemindersPausedNoticeProps) {
  return (
    <div
      role="status"
      data-testid="reminders-paused-notice"
      className={classNames(classes.notice, className, { [classes.inline]: variant === 'inline' })}
    >
      <BellOff className={classes.icon} aria-hidden="true" />
      <div className={classes.message}>{children}</div>
      {aside && <div className={classes.aside}>{aside}</div>}
    </div>
  )
}
